<template>
  <div class="log">
    <el-tabs v-model="activeName" @tab-click="handleClick" style="background-color: #ffffff; min-height: calc(100vh - 168px);">
      <!-- 控制台日志 ssssssssss -->
      <el-tab-pane name="console">
        <span slot="label">控制台操作记录</span>
        <!-- 过滤器 -->
        <el-row>
          <el-col style="text-align:right">
            <el-form size="small" :inline="true" :model="filterConsole">
              <el-form-item>
                <el-input
                  style="width: 220px;"
                  v-model="filterConsole.keyword"
                  placeholder="姓名/账号"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="filterConsole.timePicker"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :default-time="['00:00:00', '23:59:59']"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 240px;"
                />
              </el-form-item>
              <el-form-item>
                <el-button @click="filterConsoleSearch()">查询</el-button>
                <el-button @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!-- 表格内容 -->
        <el-row>
          <el-col>
            <el-table
              :data="listConsole"
              style="border: 1px solid #EEEEEE; border-bottom: 0;"
              tooltip-effect="dark"
              :header-cell-style="{ background: '#f9f9f9', color: '#000000' }"
            >
              <el-table-column label="操作人" prop="operationPersonal">
                <template slot-scope="scope">
                  {{
                    scope.row.operationPersonal +
                      "(" +
                      scope.row.operationAccount +
                      ")"
                  }}
                </template>
              </el-table-column>
              <el-table-column label="操作模块" prop="operationModules">
                <template slot-scope="scope">
                  <span>{{operateSet[scope.row.operationModules].label}}</span>
                </template>
              </el-table-column>
              <el-table-column label="IP" prop="ip"></el-table-column>
              <el-table-column
                label="操作详情"
                prop="operationDetail"
              ></el-table-column>
              <el-table-column
                label="操作时间"
                prop="operationTime"
              >
                <template slot-scope="scope">
                  <div class="type-icon-sty">
                    {{scope.row.operationTime}}&nbsp;&nbsp;
                    <img v-show="scope.row.operationSource == 1 && !isInDingTalk" src="/images/icon/dingIcon.png" alt="钉钉">
                  </div>
                </template>
              </el-table-column>
              <no-data text="暂无数据" slot="empty" />
            </el-table>
          </el-col>
        </el-row>
        <!-- 分页栏 -->
        <el-row>
          <el-col style="padding: 30px 0;" class="page-flex-end">
            <el-pagination
              @size-change="handleSizeChangeConsole"
              @current-change="handleCurrentChangeConsole"
              :current-page="filterConsole.itemPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="filterConsole.pageSize"
              layout="sizes, prev, pager, next, total"
              :total="filterConsole.pageTotal"
            />
            <el-go
              :page-size="filterConsole.pageSize"
              :total="filterConsole.pageTotal"
              @current-change="handleCurrentChangeConsole"
            ></el-go>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!-- 控制台日志 eeeeeeeeee -->
      <!-- 签章日志 ssssssssss -->
      <el-tab-pane name="signature">
        <span slot="label">合同盖章记录</span>
        <!-- 过滤器 -->
        <el-row>
          <el-col>
            <el-form
              :inline="true"
              :model="filterSignature"
              size="small"
              style="text-align:right"
            >
              <el-form-item>
                <el-input
                  style="width: 220px;"
                  v-model="filterSignature.user"
                  placeholder="姓名/账号"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  style="width: 220px;"
                  v-model="filterSignature.id"
                  placeholder="签章ID"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="filterSignature.timePicker"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :default-time="['00:00:00', '23:59:59']"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 240px;"
                />
              </el-form-item>
              <el-form-item>
                <el-button @click="filterSignatureSearch()">查询</el-button>
                <el-button @click="resetSign">重置</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!-- 表格内容 -->
        <el-row>
          <el-col>
            <el-table
              :data="listSignature"
              style="border: 1px solid #EEEEEE; border-bottom: 0;"
              tooltip-effect="dark"
              :header-cell-style="{ background: '#f9f9f9', color: '#000000' }"
            >
              <el-table-column
                label="用章人"
                prop="targetId"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.userName + "(" + scope.row.targetId + ")" }}
                </template>
              </el-table-column>
              <el-table-column
                label="用章审核人"
                prop="approver"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.approver || "无审核流程" }}
                </template>
              </el-table-column>
              <el-table-column label="操作内容" prop="info"></el-table-column>
              <el-table-column label="签署时间" prop="createTime">
                <template
                  slot-scope="scope"
                  v-if="scope.row && scope.row.createTime"
                >
                  <div class="type-icon-sty">
                    {{ scope.row.createTime | formatDateTime }}&nbsp;&nbsp;
                    <img v-show="scope.row.operationSource == 1" src="/images/icon/dingIcon.png" alt="钉钉">
                  </div>
                </template>
              </el-table-column>
              <no-data text="暂无数据" slot="empty" />
            </el-table>
          </el-col>
        </el-row>
        <!-- 分页栏 -->
        <el-row>
          <el-col style="padding: 30px 0;" class="page-flex-end">
            <el-pagination
              @size-change="handleSizeChangeSignature"
              @current-change="handleCurrentChangeSignature"
              :current-page="filterSignature.itemPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="filterSignature.pageSize"
              layout="sizes, prev, pager, next, total"
              :total="filterSignature.pageTotal"
            />
            <el-go
              :page-size="filterSignature.pageSize"
              :total="filterSignature.pageTotal"
              @current-change="handleCurrentChangeSignature"
            ></el-go>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!-- 签章日志 eeeeeeeeee -->
    </el-tabs>
  </div>
</template>

<script>
import ElGo from "../../components/go/Go";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { isInDingTalk } from "@/assets/js/utils/ding-env";
export default {
  name: "log",
  data() {
    return {
      isInDingTalk,
      // tab选项卡当前选中名称
      activeName: "console",
      // --------------------------------------------------------------------------------------------------------
      // 签章日志
      // 过滤器
      listSignature: [],
      filterSignature: {
        user: "",
        id: "",
        timePicker: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      // --------------------------------------------------------------------------------------------------------
      // 控制台日志
      // 过滤器
      listConsole: [],
      filterConsole: {
        keyword: "",
        timePicker: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      // --------------------------------------------------------------------------------------------------------
      operateSet:[
        {label:'成员管理',key:0,},
        {label:'权限组管理',key:1,},
        {label:'组织管理',key:2,},
        {label:'签章管理',key:3,},
        {label:'合同管理',key:4,},
        {label:'模板管理',key:5,},
        {label:'成员合同审批',key:6,},
        {label:'合同作废',key:7,},
      ]
    };
  },
  components: { ElGo },
  created() {
    this.queryToolSignature();
    this.queryToolConsole();
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    // tab change event
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // resetSign 重置
    resetSign() {
      this.filterSignature = {
        user: "",
        id: "",
        timePicker: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0
      };
      this.filterSignatureSearch();
    },
    // 签章日志搜索
    filterSignatureSearch() {
      this.queryToolSignature();
    },
    handleSizeChangeSignature(val) {
      this.filterSignature.itemPage = 1;
      this.filterSignature.pageSize = val;
      this.queryToolSignature();
    },
    handleCurrentChangeSignature(val) {
      this.filterSignature.itemPage = val;
      this.queryToolSignature();
    },
    // 签章日志查询工具
    queryToolSignature() {
      let params = {};
      params.itemPage = this.filterSignature.itemPage; // 页数
      params.pageSize = this.filterSignature.pageSize; // 页长
      params.beginDate = "";
      params.endDate = "";
      if (this.filterSignature.timePicker) {
        params.beginDate = this.filterSignature.timePicker[0]; // 开始时间 yyyy-MM-dd,必须与endDate同时存在才生效
        params.endDate = this.filterSignature.timePicker[1]; // 结束时间 yyyy-MM-dd,必须与beginDate同时存在才生效
      }
      params.targetId = this.filterSignature.user;
      params.sealId = this.filterSignature.id;

      ApiCorpMethods.LogController.findSealLogByPaged(params)
        .then(res => {
          if (res.code === "0") {
            this.listSignature = res.data;
            this.filterSignature.pageTotal = res.total;
          } else {
            this.listSignature = [];
            this.filterSignature.pageTotal = 0;
            this.$message.error(res.description || "获取签章日志数据失败");
          }
        })
        .catch(error => {
          console.info(error);
          this.$message.error(error);
        });
    },
    // 重置
    reset() {
      this.filterConsole = {
        keyword: "",
        timePicker: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0
      };
      this.filterConsoleSearch();
    },
    // 控制台日志搜索
    filterConsoleSearch() {
      this.queryToolConsole();
    },
    handleSizeChangeConsole(val) {
      this.filterConsole.itemPage = 1;
      this.filterConsole.pageSize = val;
      this.queryToolConsole();
    },
    handleCurrentChangeConsole(val) {
      this.filterConsole.itemPage = val;
      this.queryToolConsole();
    },
    // 控制台日志查询工具
    queryToolConsole() {
      let params = {};
      params.itemPage = this.filterConsole.itemPage; // 页数
      params.pageSize = this.filterConsole.pageSize; // 页长
      params.beginDate = "";
      params.endDate = "";
      if (this.filterConsole.timePicker) {
        params.beginDate = this.filterConsole.timePicker[0]; // 开始时间 yyyy-MM-dd,必须与endDate同时存在才生效
        params.endDate = this.filterConsole.timePicker[1]; // 结束时间 yyyy-MM-dd,必须与beginDate同时存在才生效
      }
      params.nameOrAccount = this.filterConsole.keyword;

      ApiCorpMethods.LogController.findLogByPage(params)
        .then(res => {
          if (res.code === "0") {
            this.listConsole = res.data;
            this.filterConsole.pageTotal = res.total;
          } else {
            this.listConsole = [];
            this.filterConsole.pageTotal = 0;
            this.$message.error(res.description || "获取签章日志数据失败");
          }
        })
        .catch(error => {
          console.info(error);
          this.$message.error(error);
        });
    }
  },
  beforeDestroy() {}
};
</script>

<style scoped>
.log {
  padding: 10px 20px;
}
.log >>> .el-tabs__item.is-active {
  color: #f10e0e;
}
.log >>> .el-tabs__active-bar {
  background-color: #f10e0e;
}
.log >>> .el-form-item {
  margin-bottom: 10px;
}
</style>
<style lang="less" scoped>
.type-icon-sty{
  display: flex;
  align-items: center;
  >img{
    width: 15%;
  }
}
.log {
  padding: 0;
  border-radius: 2px;
  background: #ffffff;
  /deep/ .el-tabs__header {
    padding-top: 10px;
  }
  /deep/ .el-tabs__content {
    padding: 10px 20px;
  }

  /deep/ .el-tabs__item {
    color: rgba(41, 2, 2, 1);
    &.is-active {
      font-weight: bold;
    }
    /*span {*/
    /*  padding: 0 15px;*/
    /*}*/
  }

  /*/deep/ .el-table__body-wrapper {*/
  /*  height: calc(100vh - 430px);*/
  /*  overflow-y: auto;*/
  /*}*/
}
</style>



// WEBPACK FOOTER //
// pages/console/log.vue